<template>
    <div class="two-column-rich-text grid grid__base">
        <div class="grid--container">
            <div class="grid--row">
                <div class="two-column-rich-text--col grid--col" v-for="(plugin, pluginIdx) in plugins" :key="pluginIdx">
                    <component :is="plugin.type" :is-nested="true" v-bind="bindCmsPluginAttrs(plugin)"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { bindCmsPluginAttrs } from 'util/vue/django-cms-spa';
    import cmsPluginMixin from 'framework/mixins/cms/cms-plugin';

    export default {
        mixins: [
            cmsPluginMixin,
        ],
        methods: {
            bindCmsPluginAttrs,
        },
    };
</script>
